"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withIconComponent = _interopRequireDefault(require("../withIconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Plus = function Plus() {
  return /*#__PURE__*/_react["default"].createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 7v10M17 12H7"
  }));
};

var _default = (0, _withIconComponent["default"])("UiPlus", false)(Plus);

exports["default"] = _default;